import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Components
import { MfaComponent } from '../views/mfa/mfa.component';
import { DashboardComponent } from '../views/dashboard/dashboard.component';
import { IoNewsComponent } from '../views/io-news/io-news.component';
import { IoBlogComponent } from '../views/io-blog/io-blog.component';
import { FormsComponent } from '../views/forms/forms.component';
import { HelpLineComponent } from '../views/custom-pages/help-line/help-line.component';
import { LocalResourcesComponent } from '../views/custom-pages/local-resources/local-resources.component';
import { LearnAboutIoComponent } from '../views/custom-pages/learn-about-io/learn-about-io.component';
import { ErrorComponent } from '../views/error/error.component';
import { LandingComponent } from '../views/public/landing/landing.component';
import { ContactUsComponent } from '../views/public/contact-us/contact-us.component';
import { CustomPageComponent } from '../views/public/custom-page/custom-page.component';
import { WizardComponentRegister } from '../views/wizard/wizard.component';
import { StartSurveyComponent } from '../views/start-survey/start-survey.component';
import { EditUserComponent } from '../views/user/edit/edit.component';
import { SubscriptionsComponent } from '../views/user/subscriptions/subscriptions.component';
import { ForgotPasswordComponent } from '../views/public/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../views/public/reset-password/reset-password.component';
import { DownloadReportComponent } from '../views/download-report/download-report.component'
import { ContinueWithSSOComponent } from '../views/public/continue-with-sso/continue-with-sso.component';

// Guards
import { CanActivateViaOAuthGuard } from '../guards/oAuth.canActivateGuard';
import { LoggedInGuard } from '../guards/logged-inGuard.module';
import { FormDeactivateGuard } from '../guards/form.deactivate';
import { RegistrationDeactivateGuard } from '../guards/registration.deactivate';

const routes: Routes = [
    {
        path: '',
        component: DashboardComponent,
        canActivate: [CanActivateViaOAuthGuard],
    },
    {
        path: 'login',
        component: LandingComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'mfaLogin',
        component: MfaComponent
    },
    {
        path: 'privacy-policy',
        component: CustomPageComponent
    },
    {
        path: 'terms-conditions',
        component: CustomPageComponent
    },
    {
        path: 'contact-us',
        component: ContactUsComponent
    },
    {
        path: 'forgotPassword',
        component: ForgotPasswordComponent
    },
    {
        path: 'continueWithSSO',
        component: ContinueWithSSOComponent
    },
    {
        path: 'forgotPassword/:token',
        component: ForgotPasswordComponent
    },
        {
        path: 'resetPassword',
        component: ResetPasswordComponent
    },
    {
        path: 'resetPassword/:token',
        component: ResetPasswordComponent
    },
    {
        path: 'logout',
        component: LandingComponent,
    },
    {
        path: 'error',
        component: ErrorComponent,
        canActivate: [CanActivateViaOAuthGuard]
    },
    {
        path: 'io-news',
        component: IoNewsComponent,
        canActivate: [CanActivateViaOAuthGuard]
    },
    {
        path: 'io-news/:id',
        component: IoBlogComponent,
        canActivate: [CanActivateViaOAuthGuard]
    },
    {
        path: 'help-line',
        component: HelpLineComponent,
        canActivate: [CanActivateViaOAuthGuard]
    },
    {
        path: 'local-resources',
        component: LocalResourcesComponent,
        canActivate: [CanActivateViaOAuthGuard]
    },
    {
        path: 'learn-about-io',
        component: LearnAboutIoComponent,
        canActivate: [CanActivateViaOAuthGuard]
    },
    {
        path: 'form/startInstance/:formInstanceId',
        component: FormsComponent,
        canActivate: [CanActivateViaOAuthGuard],
        canDeactivate: [FormDeactivateGuard]
    },
    {
        path: 'user/edit',
        component: EditUserComponent,
        canActivate: [CanActivateViaOAuthGuard]
    },
    {
        path: 'user/edit-notifications',
        component: SubscriptionsComponent,
        canActivate: [CanActivateViaOAuthGuard]
    },
    {
        path: 'unsubscribe/:idUserProfile/:token',
        component: SubscriptionsComponent
    },
    {
        path: 'onsiteRegistration',
        component: WizardComponentRegister,
        canDeactivate: [RegistrationDeactivateGuard]
    },
    {
        path: 'startSurvey',
        component: StartSurveyComponent
    },
    {
      path: 'startSurvey/:token',
      component: StartSurveyComponent
    },
    {
        path: 'downloadReport',
        component: DownloadReportComponent
    },
    {
        path: '404',
        component: ErrorComponent,
        canActivate: [CanActivateViaOAuthGuard]
    },
    {
        path: '**',
        redirectTo: '/404'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })
    ],
    exports: [
        RouterModule
    ],
    declarations: []
})
export class AppRoutingModule { }
